import { render } from "./VoucherCodeActivity.vue?vue&type=template&id=880e0852&scoped=true"
import script from "./VoucherCodeActivity.vue?vue&type=script&lang=js"
export * from "./VoucherCodeActivity.vue?vue&type=script&lang=js"

import "./VoucherCodeActivity.vue?vue&type=style&index=0&id=880e0852&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880e0852"]])

export default __exports__